import { render, staticRenderFns } from "./CommunityUnitBusinessNewsDetail.vue?vue&type=template&id=1d901325&scoped=true&"
import script from "./CommunityUnitBusinessNewsDetail.vue?vue&type=script&lang=js&"
export * from "./CommunityUnitBusinessNewsDetail.vue?vue&type=script&lang=js&"
import style0 from "./CommunityUnitBusinessNewsDetail.vue?vue&type=style&index=0&id=1d901325&prod&scoped=true&lang=css&"
import style1 from "./CommunityUnitBusinessNewsDetail.vue?vue&type=style&index=1&id=1d901325&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d901325",
  null
  
)

export default component.exports